import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  max-height: 90vh;
  overflow: auto;
  input {
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  
    /* Firefox */
    &[type="number"] {
      -moz-appearance: textfield;
    }
  }
 ol {
  padding-inline-start: 20px;
  margin: 0;
 }
`

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const OTPwrapper = styled.form`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  direction: ltr;
`

const Input = styled.input`
  background: white;
  font-family: IRANSans;
  width: 100%;
  letter-spacing: 20px;
  border: 0.5px solid gray;
  border-radius: 4px;
  outline: none;
  height: 40px;
  font-size: 16px;
  text-align: center;
  filter: drop-shadow(0px 0px 5px #c4c4c450);
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type="number"] {
    -moz-appearance: textfield;
  }
`;
export { Input };

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const FaqTitle = styled.div`
  display: flex;
  justify-content: flex-end;
 `

export const ResendCode = styled.span`
 font-family: IRANSans;
 font-style: normal;
 font-weight: 400;
 font-size: 12px;
 line-height: 17px;
 color: #0C68F4;
 margin-bottom: 0;
 position: relative;
 top: -10px;
 text-align: center;
 &.clickable {
   cursor: pointer;
 }
`
